<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import type { Coordinates, UserAction } from '$lib/components/map/types';
	import type { Result } from '$lib/components/search/types';
	import type { ClassValue } from 'svelte/elements';
	import { SearchAddressStore } from '$houdini';
	import { onMount, type Snippet } from 'svelte';
	import SearchInputWithQuery from '../SearchInputWithQuery.svelte';

	type Results = Result[];

	interface Props {
		proximity: Coordinates;
		initialValue?: string;
		icon?: IconName;
		id?: string;
		class?: ClassValue;
		forceOpenInput?: boolean;
		onclick?: () => void;
		onSelect?: (params: {
			result: Result | null;
			userAction: UserAction | null;
			isFromStore: boolean;
			results: Results | null;
			searchId: string | undefined;
		}) => void;
		onActivate?: () => void;
		onDeactivate?: () => void;
		beforeListItems?: Snippet<[onmouseover: (index: number) => void, activeItemIndex: number, value: string]>;
	}

	const {
		proximity,
		initialValue = '',
		icon,
		id = 'address-search',
		onclick,
		class: classes,
		onSelect,
		onActivate,
		onDeactivate,
		beforeListItems,
		forceOpenInput = false,
	}: Props = $props();

	let queryStore: SearchAddressStore | undefined = $state();

	onMount(() => {
		queryStore = new SearchAddressStore();
	});
</script>

<SearchInputWithQuery
	{id}
	{icon}
	{queryStore}
	resultToLabel={searchAddress => ({
		label: 'formattedName' in searchAddress ? searchAddress.formattedName : '',
		additionalLabel:
			('contextualizedName' in searchAddress && searchAddress.contextualizedName) || undefined,
	})}
	queryToVariables={q => ({ query: q, proximity })}
	getStoreResults={results => results?.searchAddress}
	hasTrackingEnabled
	hasHistoryEnabled
	{initialValue}
	class={classes}
	{onSelect}
	{onActivate}
	{onDeactivate}
	{onclick}
	{beforeListItems}
	{forceOpenInput}
/>

<style>
	:global(.search .input-container:not(:focus-within)) {
		background-color: rgba(253, 253, 254, 1);
	}

	:global(.search .input-container:has(> input:empty:not(:focus))) {
		color: rgba(164, 165, 176, 1);
	}
</style>
